import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

/**
 * Mirrors the box model of `entities/dailyBonus` (wrapper margins, padding, header
 * row, grid gaps and card sizes) so the widget keeps its height across every
 * breakpoint and the surrounding layout does not shift once the rewards resolve.
 * Height is intrinsic here for the same reason it is in the loaded widget — a fixed
 * `h-*` drifts the moment the real card sizes change.
 */
const DailyBonusSkeleton = () => {
  return (
    <section className="relative md:-mx-2 3xl:mx-0 lg:mb-4 3xl:mb-0 max-md:mt-4 rounded-2xl p-px">
      <SkeletonParent className="size-full rounded-[inherit]">
        <div className="relative z-1 py-2.75 px-2.75 md:px-1.75 md:py-2.75">
          <div className="flex items-center gap-2 md:gap-1 mb-4 md:mb-3 3xl:mb-2">
            <SkeletonChild className="size-5.5 shrink-0 rounded-full" />
            <SkeletonChild className="h-5 w-32.5 rounded-full" />
            <SkeletonChild className="h-5 w-15 ml-auto shrink-0 rounded-full" />
          </div>

          <div className="grid grid-cols-5 gap-x-2.25 gap-y-2 md:gap-y-2 md:gap-x-1">
            {Array.from({ length: 10 }).map((_, index) => (
              <SkeletonChild key={index} className="h-16.5 md:w-10.25 md:h-13 3xl:h-13.5 3xl:w-11.5 rounded-[0.5rem]" />
            ))}
          </div>

          <div className="flex justify-center mt-4 md:mt-3">
            <SkeletonChild className="h-4 w-60.5 lg:w-57.5 rounded-lg" />
          </div>
        </div>
      </SkeletonParent>
    </section>
  );
};

export default DailyBonusSkeleton;
